import { parseToRgb } from 'polished';
export var isDarkColor = function isDarkColor(color) {
  if (!color) {
    return false;
  }

  var rgb;

  try {
    rgb = parseToRgb(color || '#000000');
  } catch (e) {
    return false;
  } // YIQ equation from http://24ways.org/2010/calculating-color-contrast


  var yiq = (rgb.red * 2126 + rgb.green * 7152 + rgb.blue * 722) / 10000;
  return yiq < 128;
};